import { Injectable, inject } from '@angular/core';
import { BankIdAuthenticationTicket, PollResponse } from '../model';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable()
export class BankIdService {
  private httpClient = inject(HttpClient);

  private ticket: BankIdAuthenticationTicket;

  public setTicket(ticket: BankIdAuthenticationTicket): void {
    this.ticket = ticket;
  }

  public getTicket(): BankIdAuthenticationTicket {
    return this.ticket;
  }

  public authenticationRequest(
    authMethodType: string,
    id: string,
    idp: string
  ): Observable<BankIdAuthenticationTicket> {
    const params = new HttpParams().set('authMethodType', authMethodType);

    return this.httpClient.get<BankIdAuthenticationTicket>(`/bank-id/${idp}/order`, {
      headers: this.getHeaders(id),
      params: params
    });
  }

  public getStatus(id: string, sameDevice: boolean, currentQrCodeB64: string, idp: string): Observable<PollResponse> {
    if (!this.ticket) {
      return of(null);
    }

    return this.httpClient.get<PollResponse>(`/bank-id/${idp}/poll`, {
      headers: this.getHeaders(id),
      params: this.getPollParams(sameDevice, currentQrCodeB64)
    });
  }

  public cancelAuthentication(id: string, idp: string): void {
    window.location.href = `/bank-id/${idp}/cancel?id=${id}`;
  }

  private getPollParams(sameDevice: boolean, currentQrCodeB64: string): HttpParams {
    if (sameDevice || (!currentQrCodeB64 && !this.ticket?.qrStartTokenCode)) {
      return null;
    }

    let qrCodeB64 = currentQrCodeB64;
    if (!qrCodeB64 || qrCodeB64.length === 0) {
      qrCodeB64 = this.ticket.qrStartTokenCode;
    }

    return new HttpParams().set('qrCodeB64', encodeURIComponent(qrCodeB64));
  }

  private getHeaders(id: string): HttpHeaders {
    return new HttpHeaders().set('xhr', 'true').set('id', id);
  }
}
